import React from 'react';
import { Link } from 'react-router-dom';
import './ModelCard.css';

function ModelCard({ model, onDelete, onDownload }) {
  const date = new Date(model.created_at).toLocaleDateString();
  
  return (
    <div className="model-card">
      <div className="model-card-header">
        <h3>{model.name}</h3>
        <span className="model-version">v{model.version}</span>
      </div>
      
      <div className="model-card-body">
        <div className="model-info">
          <div className="info-row">
            <span className="label">Client:</span>
            <span className="value">{model.client}</span>
          </div>
          
          <div className="info-row">
            <span className="label">Classes:</span>
            <span className="value">{model.classes_count}</span>
          </div>
          
          <div className="info-row">
            <span className="label">Input Size:</span>
            <span className="value">{model.input_size}×{model.input_size}</span>
          </div>
          
          <div className="info-row">
            <span className="label">Created:</span>
            <span className="value">{date}</span>
          </div>
          
          {model.usage_count !== undefined && (
            <div className="info-row">
              <span className="label">Usage:</span>
              <span className="value">{model.usage_count} times</span>
            </div>
          )}
        </div>
      </div>
      
      <div className="model-card-actions">
        <Link to={`/test/${model.id}`} className="btn-test">
          🔬 Test
        </Link>
        
        <button onClick={() => onDownload('onnx')} className="btn-download">
          ⬇️ ONNX
        </button>
        
        {model.original_path && (
          <button onClick={() => onDownload('pt')} className="btn-download">
            ⬇️ PT
          </button>
        )}
        
        <button onClick={onDelete} className="btn-delete">
          🗑️
        </button>
      </div>
    </div>
  );
}

export default ModelCard;

